'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAuth } from '@/context/AuthContext';

interface HeaderProps {
  siteNumber?: string;
}

export default function Header({ siteNumber }: HeaderProps) {
  const pathname = usePathname();
  const { user, logout } = useAuth();

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      {/* Left side — sidebar toggle */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a
            className="nav-link"
            data-widget="pushmenu"
            href="#"
            role="button"
            onClick={(e) => e.preventDefault()}
          >
            <i className="fas fa-bars" />
          </a>
        </li>

        {/* Breadcrumb in navbar */}
        <li className="nav-item d-none d-sm-inline-block">
          <Link href="/" className="nav-link" style={{ color: '#8898aa', fontSize: '0.85rem' }}>
            Home
          </Link>
        </li>
        {siteNumber && (
          <>
            <li className="nav-item d-none d-sm-inline-block">
              <span className="nav-link" style={{ color: '#c8d6e5', padding: '0.5rem 0' }}>
                /
              </span>
            </li>
            <li className="nav-item d-none d-sm-inline-block">
              <Link
                href={`/sites/${siteNumber}`}
                className="nav-link"
                style={{ color: '#4e9af1', fontSize: '0.85rem', fontWeight: 600 }}
              >
                Site {siteNumber}
              </Link>
            </li>
          </>
        )}
        {pathname.includes('/query') && (
          <>
            <li className="nav-item d-none d-sm-inline-block">
              <span className="nav-link" style={{ color: '#c8d6e5', padding: '0.5rem 0' }}>/</span>
            </li>
            <li className="nav-item d-none d-sm-inline-block">
              <span className="nav-link" style={{ color: '#6c757d', fontSize: '0.85rem' }}>
                Q&amp;A
              </span>
            </li>
          </>
        )}
      </ul>

      {/* Right side */}
      <ul className="navbar-nav ml-auto">
        {/* Site indicator badge */}
        {siteNumber && (
          <li className="nav-item d-none d-md-flex align-items-center mr-2">
            <span
              style={{
                background: 'linear-gradient(135deg,#4e9af1,#2d7fe0)',
                color: '#fff',
                borderRadius: 8,
                padding: '4px 12px',
                fontSize: '0.8rem',
                fontWeight: 600,
              }}
            >
              <i className="fas fa-map-marker-alt mr-1" />
              Site {siteNumber}
            </span>
          </li>
        )}

        {/* User + Logout */}
        {user && (
          <li className="nav-item d-flex align-items-center">
            <span className="nav-link small text-muted mr-1">
              <i className="fas fa-user mr-1" />{user.username}
            </span>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={logout}
              title="Logout"
            >
              <i className="fas fa-sign-out-alt" />
            </button>
          </li>
        )}

        {/* Full-screen toggle */}
        <li className="nav-item ml-2">
          <a
            className="nav-link"
            data-widget="fullscreen"
            href="#"
            role="button"
            onClick={(e) => e.preventDefault()}
          >
            <i className="fas fa-expand-arrows-alt" />
          </a>
        </li>
      </ul>
    </nav>
  );
}
